import { render } from "./index.vue?vue&type=template&id=c608a2bc"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c608a2bc&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/extra/VabChart/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c608a2bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c608a2bc', __exports__)) {
    console.log('reload')
    api.reload('c608a2bc', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=c608a2bc", () => {
    console.log('re-render')
    api.rerender('c608a2bc', render)
  })

}


export default __exports__